
<template>
  <v-container fluid>
    <v-layout v-if="!this.$store.state.started" justify-center>
      <v-flex xs12 sm12 md8 lg8 xl8>
        <v-card>
          <v-card-title>
            <h2>Select Players</h2>
          </v-card-title>
          <v-layout row wrap justify-space-around>
            <v-flex xs12 sm12 md5 lg5 xl5 v-for="player in this.$store.state.players" :key="player.id">
              <v-btn
                v-on:click="(player.selected = !player.selected)"
                :depressed="player.selected"
                :color="player.color"
                :block="true"
              >
                {{player.name}}
                <v-icon v-if="player.selected">done</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-btn
            @click="toggleStarted()"
            v-if="this.$store.getters.selectedPlayers.length > 0"
            :color="'#a44a6d'"
            :large="true"
            :block="true"
          >Start</v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "PlayerSelection",
  methods: {
    toggleStarted() {
      this.$store.dispatch("toggleStarted");
    }
  }
};
</script>

<style>
</style>

